module.exports = __webpack_public_path__ + "assets/4be66ff5a35c3b9b96b88cc8c40af560.mp3";